import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

class FullScreenPopup extends React.Component {
    render() {
        const { isOpen, extraClasses, toggle } = this.props;
        const classes = ['fullscreen-popup'].concat(extraClasses);
        if (isOpen) {
            classes.push('is-open');
        } else {
            return null;
        }
        return (
            <div className={classes.join(' ')}>
                {toggle && (
                    <div className="close-icon" onClick={toggle}>
                        <Isvg src="../../svg/cancel.svg" />
                    </div>
                )}
                <div className="fullscreen-popup__body">{this.props.children}</div>
            </div>
        );
    }
}

FullScreenPopup.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    extraClasses: PropTypes.array,
};

FullScreenPopup.defaultProps = {
    isOpen: false,
    extraClasses: [],
    toggle: undefined,
};

export default FullScreenPopup;
